import api from "@/api";
import { roles } from "@/helpers";

const state = {
  status: "",
  token: localStorage.getItem("token") || "",
  user: JSON.parse(localStorage.getItem("authUser") || "{}")
};

// getters
const getters = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  token: state => state.token || localStorage.getItem("token") || "",
  authUser: state =>
    state.user || JSON.parse(localStorage.getItem("authUser") || "{}")
};

// mutations
const mutations = {
  auth_request(state) {
    state.status = "loading";
  },

  auth_success(state, auth) {
    // console.log("auth_success", auth.token, auth.user);
    state.status = "success";
    state.token = auth.token;
    state.user = auth.user;
  },

  auth_error(state) {
    state.status = "error";
    state.token = "";
    state.user = {};
  },

  set_user(state, user) {
    state.user = user;
  },

  logout(state) {
    state.status = "";
    state.token = "";
    state.user = {};
  }
};

// actions
const actions = {
  login({ commit }, params) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      api({
        method: "post",
        url: "auth",
        auth: {
          username: params.username,
          password: params.password
        }
      })
        .then(res => {
          const token = res.data.token;
          const user = res.data.user;
          console.log("roles: ", roles);
          console.log("roles[role]: ", roles[user.role]);
          user.role = roles[user.role];
          // console.log("updatedRole: ", roles, user);
          localStorage.setItem("token", token);
          localStorage.setItem("authUser", JSON.stringify(user));
          commit("auth_success", { token: token, user: user });
          resolve(res);
        })
        .catch(err => {
          commit("auth_error");
          localStorage.removeItem("token");
          localStorage.removeItem("authUser");
          reject(err);
        });
    });
  },
  logout({ commit }) {
    return new Promise(resolve => {
      commit("logout");
      localStorage.removeItem("token");
      localStorage.removeItem("authUser");
      resolve();
    });
  },
  changepass({ commit }, params) {
    console.log("Change password", params);
    return new Promise((resolve, reject) => {
      commit("auth_request");
      const user = localStorage.getItem("authUser");
      api
        .put(
          `users/${user.id}/password`,
          { password: params.password },
          { auth: { username: user.email, password: params.oldPassword } }
        )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          commit("auth_error");
          reject(err);
        });
    });
  },
  checkAuth({ commit, dispatch }) {
    // console.log("Checking auth");
    return new Promise((resolve, reject) => {
      commit("auth_request");
      api
        .get("users/me")
        .then(res => {
          const user = res.data;
          user.role = roles[user.role];
          console.debug("Auth success", user);
          localStorage.setItem("authUser", JSON.stringify(user));
          commit("set_user", user);
          resolve(res);
        })
        .catch(err => {
          commit("auth_error");
          console.debug("Auth error", err);
          dispatch("logout");
          // reject(err);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
